import { makeStyles } from '@material-ui/core/styles'

export const bottomSheetMobileInfoWindowStyles = makeStyles((theme) => ({
  mobileInfoWindowContainer: {
    display: 'flex',
    marginTop: '20px',
    paddingLeft: '10px',
  },
  mapInfoContainer: {
    padding: 10,
    zIndex: 1000,
    background: theme.palette.primary.paper,
    [theme.breakpoints.down('sm')]: {
      top: 110,
      left: 10,
    },
  },
  mapInfoCardContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  mobileMarkerInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '50dvw',
    padding: '10px',
  },
  campusContainer: { position: 'absolute', top: '10%', left: '10%' },
  campusImageContainer: {
    paddingBottom: 10,
  },
  campusImage: {
    width: '30px',
    height: 'auto',
    borderRadius: '1rem',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '150px',
    },
  },
  campusImageText: {
    color: 'white',
    background: theme.color.rutgersRed,
    fontSize: '1.4rem',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
    },
  },
  campusText: {
    fontSize: '1.4rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  mapInfoButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 1,
  },
}))

export default bottomSheetMobileInfoWindowStyles
